import { LSUErrorCode } from '@teetsh/app/src/containers/Livrets/types/livret';
import { useTranslation } from 'react-i18next';

export interface ErrorLabelAction {
  label?: string;
  link?: string;
  takeLabelFromTheBack?: boolean;
}

export const errorsMapping: Record<LSUErrorCode, ErrorLabelAction> = {
  director_family_name_incorrect: {
    link: 'configure-director',
  },
  director_given_name_incorrect: {
    link: 'configure-director',
  },
  director_has_no_gender: {
    link: 'configure-director',
  },
  director_not_found: {
    link: 'configure-director',
  },
  enseignant_family_name_incorrect: {
    link: 'configure-user',
  },
  enseignant_given_name_incorrect: {
    link: 'configure-user',
  },
  enseignant_has_no_gender: {
    link: 'configure-user',
  },
  invalid_ine: {
    link: 'configure-ine',
  },
  invalid_id_be: {
    link: 'configure-idbe',
  },
  invalid_id_be_format: {
    link: 'configure-idbe',
    takeLabelFromTheBack: true,
  },
  invalid_uai: {
    link: 'configure-uai',
  },
  no_competences: {},
  should_have_3_completed_domains: {},
  domain_has_no_competences_but_a_note: {},
  missing_livret_eleve_bilan: {},
  too_long_livret_eleve_bilan: {},
  too_long_matiere_remark: {},
  too_long_competence_name: {},
  empty_competence_name: {},
};

export function useLSUErrorsMapping() {
  const { t } = useTranslation(['carnet']);
  return (
    error: LSUErrorCode,
    params: { [key: string]: string } = {},
  ): ErrorLabelAction | undefined => {
    const match = errorsMapping[error];
    const label = t(
      `carnet:livret.lsuErrorsMapping.${error}`,
      params as any,
    ) as string;
    if (match) {
      return {
        ...match,
        label,
      };
    }
    return undefined;
  };
}
